
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  components: {
    Paginator: () => import('@/components/Paginator.vue'),
    SortColumn: () => import('@/components/SortColumn.vue'),
    Modal: () => import('@/components/Modal.vue'),
    ExportButton: () => import("@/components/ExportButton.vue")
  },
  computed: {
    years() {
      let years: any = [];
      for (let i: number = new Date().getFullYear(); i >= 2000; i--) {
        years.push(i);
      }
      return years;
    },
  },
  filters: {
    date(value) {
      return value ? moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
    },
  },
  watch: {
    $route: {
      handler: async function(to, from) {
        await (this as any).init();
      },
    },
  },
})
export default class Requests extends Vue {
  exportApiUrl: string = "requests/exportxls";
  dictionary: any = {};
  title: string = '';
  filter: any = {
    companyId: this.$store.state.companyId,
    controlZoneId: '',
    month: '',
    year: '',
    reporttype: '',
    branchId: '',
    trimester: '',
    status: '',
    code: '',
    requestNumber: '',
    seguredName: '',
    modifyType: -1,
    policy_number: '',
  };
  currentRequest: number = 0;
  requests: any = [];
  companies: any = [];
  subscriptors: any = [];
  branches: any = [];
  months: any = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Augosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];
  statuses: any = [];
  massiveUploads: any = [];
  trimesters: any = [];
  limit: number = 5;
  totalRows: number = 0;
  sortColumns: Record<string, string> = {
    name: 'Empresa',
    owner: 'Responsable',
    deletedAt: 'Estado',
  };
  currentSort: Record<string, string> = {
    col: 'requests.status',
    dir: 'desc',
  };

  async mounted() {
    await this.loadDictionary();
    await this.loadCompanies();
    await this.loadSubscriptors();
    await this.loadBranches();
    await this.init();
  }

  async init() {
    if (this.$route.name === 'client-endorsments-without-movement') {
      this.filter.modifyType = 1;
      this.title = 'Endosos sin movimientos';
    } else if (this.$route.name === 'client-endorsments-with-movement') {
      this.filter.modifyType = 2;
      this.title = 'Endosos con movimientos';
    } else {
      this.filter.modifyType = -1;
      this.title = 'Consultar Solicitudes';
    }
    await this.loadMassiveUploads();
    await this.loadTrimesters();
    await this.loadStatuses();
    await (this as any).loadRequests(1, this.currentSort);
  }

  showDeleteModal(id: number) {
    this.currentRequest = id;
    (this.$refs.modal as any).show();
  }

  async deleteRequest() {
    try {
      let response: any = await (this.$root as any)._delete(
        `requests/${this.currentRequest}`
      );
      await (this as any).loadRequests(1, this.currentSort);
      (this.$refs.modal as any).hide();
      (this.$root as any).notify('Se elimino la solicitud con éxito.');
    } catch (e) {
      (this.$root as any).notify('No se pudo eliminar la solicitud.', 'error');
    }
  }

  async exportRequests() {
    try {
      const response: any = await (this.$root as any)._post(
        'requests/exportxls',
        {
          ...this.filter,
        }
      );
      window.open(response.path);
    } catch (e) {
      (this.$root as any).notify(
        'No se pudo exportar, intente más tarde.',
        'error'
      );
    }
  }

  async clearFilters() {
    Object.keys(this.filter).forEach((key: any) => {
      if (key !== 'modifyType' && key !== 'companyId') {
        this.filter[key] = '';
      }
    });
    (this as any).$refs['paginator'].changePage(1);
  }
  subscriptor(id) {
    let subscriptor: any[] = this.subscriptors.filter(
      (subscriptor) => subscriptor.id === id
    );
    return subscriptor[0].fullname;
  }
  momentify(date) {
    let formattedDate: any = '';
    if (date) formattedDate = moment(date).format('DD/MM/YYYY');
    return formattedDate;
  }
  statusClass(status) {
    if (status === 0 || status === 1) return 'active';
    if (status === 5) return 'pending';
    return 'inactive';
  }

  async onPageChange(page: number, limit: number) {
    this.limit = limit;
    await (this as any).loadRequests(page, this.currentSort);
  }

  async loadRequests(
    page: number,
    sort: Record<string, string>,
    showPopup: boolean
  ) {
    this.currentSort = sort;
    this.filter.controlZoneId = this.filter.controlZoneId === 'NULL' ? null : this.filter.controlZoneId;
    const response: any = await (this.$root as any)._post('requests/all', {
      limit: this.limit,
      page: page,
      order: this.currentSort,
      models: 'companies,branches',
      ...this.filter,
    });
    this.totalRows = response.totalRows;
    this.requests = response.data;
    if (showPopup)
      (this.$root as any).notify('Busqueda realizada con éxito', 'success');
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get('requests/dictionary');
    this.dictionary = response;
  }

  async loadCompanies() {
    const response: any = await (this.$root as any)._post('companies/all');
    this.companies = response.data;
  }

  async loadSubscriptors() {
    const response: any = await (this.$root as any)._post('subscriptors/all');
    this.subscriptors = response.data;
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get('branches');
    this.branches = response.data;
  }

  async loadTrimesters() {
    const response: any = await (this.$root as any)._get('requests/trimesters');
    this.trimesters = response;
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get('requests/status');
    this.statuses = response;
  }

  async loadMassiveUploads() {
    const response: any = await (this.$root as any)._post(`companies/${this.$store.state.companyId}/massiveUploads`, {
      status: 2,
      order: {
        col: "title",
        dir: "asc"
      }
    });

    this.massiveUploads = response.data.map(mu => {
      mu.createdAt = moment(mu.createdAt).format("LLL");
      return mu;
    });
  }
}
